import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Tooltip } from '@ow/comps'
import tw from 'twin.macro'
import { dayjsInit } from '@ow/utils'
import { useTbViewStore } from '@vt/hooks'
import { pick } from 'lodash-es'
import NoticeComment from './NoticeComment'

const Container = styled.div`
  width: 800px;
  margin: auto;
  ${tw`flex flex-col gap-5`}
`
const Title = styled.div`
  font-size: 28px;
  font-weight: var(--font-weight-bolder);
  color: rgba(0, 0, 0, 0.85);
  word-break: break-all;
  ${tw`w-full`}
`
const Create = styled.div`
  color: #758697;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  font-size: 14px;
  ${tw`flex items-center gap-10 pb-3`}
`
const Content = styled.div`
  color: var(--text-gray-100);
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  ${tw`pb-5`}
  div {
    word-break: break-all;
    ${tw`w-full`}
  }
`
const Enclosure = styled.div`
  font-size: 14px;
  ${tw`flex items-center justify-between hover:text-primary-500 hover:bg-primary-50 py-0.5 px-3`}
  &:hover {
    .download {
      display: flex;
      justify-content: end;
    }
  }
  .download {
    ${tw`hidden cursor-pointer`}
  }
`

const NoticeDetail = function ({ data }) {
  const [currentData, setCurrentData] = useState({})

  const { fetchTbDataById } = useTbViewStore((state) =>
    pick(state, ['fetchTbDataById'])
  )
  console.log('props====', data)
  useEffect(() => {
    fetchTbDataById(data.objectId).then((res) => {
      console.log('aaabb', res)
      setCurrentData(res.currentData)
    })
  }, [])

  return (
    Object.keys(currentData).length !== 0 && (
      <Container>
        <Title>{currentData.announcementTitle}</Title>
        <Create>
          <div>发布者: {currentData.createdBy.name}</div>
          <div className="cursor-pointer">
            <Tooltip
              trigger={<div>已读: {currentData.readNum}</div>}
              position="bottom"
              on={['click']}
            >
              {currentData.read && currentData.read.length !== 0 ? (
                currentData.read.map((r) => {
                  return <div>{r.title}</div>
                })
              ) : (
                <div>无</div>
              )}
            </Tooltip>
          </div>
          <div className="cursor-pointer">
            <Tooltip
              trigger={<div>未读: {currentData.unreadNum}</div>}
              position="bottom"
              on={['click']}
            >
              <div>
                {currentData.unread && currentData.unread.length !== 0 ? (
                  currentData.unread.map((r) => {
                    return <div>{r.title}</div>
                  })
                ) : (
                  <div>无</div>
                )}
              </div>
            </Tooltip>
          </div>
          <div>{dayjsInit(currentData.createdAt).format('YYYY-MM-DD')}</div>
        </Create>
        <Content>
          <div>{currentData.announcementContent}</div>
        </Content>
        {currentData.enclosure && currentData.enclosure.length && (
          <Content>
            <div style={{ fontSize: '24px' }} className="mb-2 font-weight-bold">
              附件
            </div>
            <div className="flex flex-col gap-2">
              {(currentData.enclosure || []).map((enc) => {
                return (
                  <Enclosure key={enc.name}>
                    <div>{enc.filename}</div>
                    <div
                      className="download"
                      onClick={() => {
                        // eslint-disable-next-line prefer-destructuring
                        window.location.href = enc.src
                      }}
                    >
                      下载
                    </div>
                  </Enclosure>
                )
              })}
            </div>
          </Content>
        )}
        <NoticeComment id={currentData.objectId} />
      </Container>
    )
  )
}

export default NoticeDetail
